import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface MapPinIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const MapPinIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: MapPinIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <g clipPath="url(#clip0_1_5756)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 9.8C19 13.7585 13.6628 18.581 12.3092 19.7405C12.1299 19.894 11.8701 19.894 11.6908 19.7405C10.3372 18.581 5 13.7585 5 9.8C5 6.04446 8.13401 3 12 3C15.866 3 19 6.04446 19 9.8Z"
                    stroke={color}
                    strokeWidth={2}
                    strokeLinecap="round"
                />
                <path
                    d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
                    stroke={color}
                    strokeWidth={2}
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_5756">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default MapPinIcon
